import { useMsal } from '@azure/msal-react';
import { API_LOGIN_REQUEST } from '../auth/msalConfig';
import { Icon } from './Icon';

export function LoginScreen() {
  const { instance } = useMsal();

  const signIn = () => {
    instance.loginRedirect(API_LOGIN_REQUEST).catch(console.error);
  };

  return (
    <div className="flex flex-col items-center justify-center h-full p-8 bg-surface">
      <div className="flex items-center gap-3 mb-2">
        <img src="/kairos-icon.png" alt="" width={48} height={48} className="rounded-md" />
        <div>
          <h1 className="text-2xl font-bold">Kairos</h1>
          <p className="text-text-muted">Trailhead AI</p>
        </div>
      </div>
      <p className="text-center max-w-md mt-6 mb-6">
        Sign in with your Trailhead account to search policies, project history, and team knowledge —
        answered with sources.
      </p>
      <button
        onClick={signIn}
        className="bg-primary hover:bg-primary-hover text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2"
      >
        <Icon name="i-lock" size={16} />
        Sign in with Microsoft
      </button>
    </div>
  );
}
